export function shouldBlockLegacyDeviceSync(isIdart2ServiceInstalled: boolean): boolean {
    return isIdart2ServiceInstalled;
}
